import { render } from "./Radio.vue?vue&type=template&id=4f33a264&scoped=true&ts=true"
import script from "./Radio.vue?vue&type=script&lang=ts"
export * from "./Radio.vue?vue&type=script&lang=ts"

import "./Radio.vue?vue&type=style&index=0&id=4f33a264&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f33a264"]])

export default __exports__